export default {
    // 格式化日期, YYYY/MM/DD
    formatDate(ts: string) {
        let d = new Date(ts)
        let YYYY = d.getFullYear()
        let MM = d.getMonth() + 1
        let DD = d.getDate()

        if(ts) {
            return YYYY + '.' + MM + '.' + DD
        }else {
            return ''
        }

    }
}